var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGestisciAppuntamento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_9",
    "data-name": "Rettangolo 9",
    width: 32,
    height: 32,
    transform: "translate(1172.272 470.321)",
    fill: "#fff",
    stroke: "#056726",
    strokeLinecap: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8514",
    "data-name": "Raggruppa 8514",
    transform: "translate(742 12545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8499",
    "data-name": "Raggruppa 8499",
    transform: "translate(188 300)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4662",
    "data-name": "Rettangolo 4662",
    width: 50,
    height: 50,
    rx: 14,
    transform: "translate(-930 -12845)",
    fill: "#056726"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8493",
    "data-name": "Raggruppa 8493",
    transform: "translate(37 89.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8509",
    "data-name": "Raggruppa 8509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prenota_appuntamento",
    transform: "translate(-1942.272 -13095.94)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar_1_",
    "data-name": "calendar (1)",
    transform: "translate(1174.15 472.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_15",
    "data-name": "Raggruppa 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_14",
    "data-name": "Raggruppa 14"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_3",
    "data-name": "Ellisse 3",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(20.234 10.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M23.883,2.211H22.445V1.106a1.106,1.106,0,1,0-2.211,0V2.211H15.2V1.106a1.106,1.106,0,1,0-2.211,0V2.211H8.014V1.106a1.106,1.106,0,1,0-2.211,0V2.211H4.423A4.428,4.428,0,0,0,0,6.634V23.883a4.428,4.428,0,0,0,4.423,4.422h8.458a1.106,1.106,0,1,0,0-2.211H4.423a2.214,2.214,0,0,1-2.211-2.211V6.634A2.214,2.214,0,0,1,4.423,4.423H5.805V5.529a1.106,1.106,0,1,0,2.211,0V4.423h4.978V5.529a1.106,1.106,0,1,0,2.211,0V4.423h5.029V5.529a1.106,1.106,0,1,0,2.211,0V4.423h1.437a2.214,2.214,0,0,1,2.211,2.211v6.3a1.106,1.106,0,1,0,2.211,0v-6.3a4.428,4.428,0,0,0-4.422-4.423Z",
    fill: "#fff",
    stroke: "#056726",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_4",
    "data-name": "Ellisse 4",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(15.424 10.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_5",
    "data-name": "Ellisse 5",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(10.614 15.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_6",
    "data-name": "Ellisse 6",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(5.805 10.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_7",
    "data-name": "Ellisse 7",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(5.805 15.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_8",
    "data-name": "Ellisse 8",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(5.805 20.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_9",
    "data-name": "Ellisse 9",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(10.614 20.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_10",
    "data-name": "Ellisse 10",
    cx: 1.106,
    cy: 1.106,
    r: 1.106,
    transform: "translate(10.614 10.504)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "management-service",
    d: "M40.361,35.486a.629.629,0,0,0,.627-.544,7.158,7.158,0,0,0,0-1.986.629.629,0,0,0-.627-.546h-.695a5.846,5.846,0,0,0-.578-1.393l.491-.492a.629.629,0,0,0,.058-.83,7.117,7.117,0,0,0-1.4-1.4.629.629,0,0,0-.831.057l-.491.491a5.828,5.828,0,0,0-1.393-.578v-.7a.629.629,0,0,0-.543-.627,7.188,7.188,0,0,0-1.986,0,.629.629,0,0,0-.546.627v.7a5.835,5.835,0,0,0-1.393.578l-.492-.491a.629.629,0,0,0-.83-.058,7.118,7.118,0,0,0-1.4,1.4.629.629,0,0,0,.057.831l.491.491a5.845,5.845,0,0,0-.578,1.393H27.6a.629.629,0,0,0-.627.543,7.158,7.158,0,0,0,0,1.986.629.629,0,0,0,.627.546h.695a5.845,5.845,0,0,0,.578,1.393l-.491.492a.629.629,0,0,0-.058.83,7.117,7.117,0,0,0,1.4,1.4.629.629,0,0,0,.831-.057l.491-.491a5.844,5.844,0,0,0,1.393.578v.7a.629.629,0,0,0,.544.627,7.158,7.158,0,0,0,1.986,0,.629.629,0,0,0,.546-.627v-.7a5.828,5.828,0,0,0,1.393-.578l.492.491a.629.629,0,0,0,.83.058,7.107,7.107,0,0,0,1.4-1.4.629.629,0,0,0-.057-.831l-.491-.491a5.844,5.844,0,0,0,.578-1.393ZM39.106,35.1a5.216,5.216,0,0,1-.688,1.66.318.318,0,0,0,.043.4l.666.666a6.467,6.467,0,0,1-1.276,1.275l-.666-.666a.318.318,0,0,0-.4-.044,5.208,5.208,0,0,1-1.66.688.318.318,0,0,0-.249.311v.942a6.538,6.538,0,0,1-1.8,0v-.942a.318.318,0,0,0-.249-.311,5.215,5.215,0,0,1-1.66-.688.318.318,0,0,0-.4.043l-.666.666a6.467,6.467,0,0,1-1.273-1.276l.666-.666a.318.318,0,0,0,.044-.4,5.208,5.208,0,0,1-.688-1.66.318.318,0,0,0-.311-.249H27.6a6.523,6.523,0,0,1,0-1.8h.941a.318.318,0,0,0,.311-.249,5.212,5.212,0,0,1,.688-1.66.318.318,0,0,0-.044-.4l-.666-.666A6.466,6.466,0,0,1,30.108,28.8l.666.666a.318.318,0,0,0,.4.043,5.216,5.216,0,0,1,1.66-.688.318.318,0,0,0,.249-.311v-.944a6.539,6.539,0,0,1,1.8,0v.941a.318.318,0,0,0,.249.311,5.216,5.216,0,0,1,1.66.688.318.318,0,0,0,.4-.043l.666-.666a6.467,6.467,0,0,1,1.275,1.276l-.666.666a.318.318,0,0,0-.044.4,5.208,5.208,0,0,1,.688,1.66.318.318,0,0,0,.311.249h.942a6.523,6.523,0,0,1,0,1.8h-.942a.318.318,0,0,0-.311.249ZM33.98,30.187a3.76,3.76,0,1,0,3.76,3.76,3.76,3.76,0,0,0-3.76-3.76Zm0,6.884A3.124,3.124,0,1,1,37.1,33.947,3.124,3.124,0,0,1,33.98,37.07Z",
    transform: "translate(-779.057 -12635.585)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestisciAppuntamento);
export default __webpack_public_path__ + "static/media/gestisci_appuntamento.54069eb7d961279e94f6a71ddb0e6a50.svg";
export { ForwardRef as ReactComponent };